import React, { useMemo } from "react";
import Protector from "../Protector";
import { RenderProtectorRoutes } from "./RenderProtectorRoutes";

const SidebarProtectorRoutes = () => {
  const { protectorRoutes } = RenderProtectorRoutes();
  const activeRoutes = useMemo(() => {
    return protectorRoutes.filter(({ moduleIsActive }) => moduleIsActive);
  }, [protectorRoutes]);
  return (
    <>
      {activeRoutes.map(({ condition, render }, index) => (
        <Protector key={`sidebar-route-${index}`} active={condition}>
          {render}
        </Protector>
      ))}
    </>
  );
};

export default SidebarProtectorRoutes;
